import Vue from 'vue'
import { mapGetters } from 'vuex'
import store from './store.js'
import {
    LiveSearch,
    CollectionComponent,
    ContinuousCollectionComponent,
    SyncsWithUrl,
    ResetsPage
} from 'clockvine-vue'
import VideoEmbed from './components/VideoEmbed.vue'

// eslint-disable-next-line no-unused-vars
const app = new Vue({
    el: '#clockvine-js',
    store,

    components: {
        resources: ContinuousCollectionComponent.for('resources'),
        resourceTypes: CollectionComponent.for('resourceTypes'),
        resourceTopics: CollectionComponent.for('resourceTopics'),
        blog: ContinuousCollectionComponent.for('blog'),
        blogCategories: CollectionComponent.for('blogCategories'),
        labs: ContinuousCollectionComponent.for('labs'),
        news: ContinuousCollectionComponent.for('news'),
        customers: ContinuousCollectionComponent.for('customers'),
        industries: CollectionComponent.for('industries'),
        partners: ContinuousCollectionComponent.for('partners'),
        partnerCategories: CollectionComponent.for('partnerCategories'),
        partnerRegions: CollectionComponent.for('partnerRegions'),
        partnerCertifications: CollectionComponent.for('partnerCertifications'),
        search: LiveSearch,
        VideoEmbed,
    },

    mixins: [
        new SyncsWithUrl('params', {
            page: () => false,
        }),
        new ResetsPage(),
    ],

    data: {
        params: {
            sortOrder: '',
            page: 1,
            search: '',
            type: null,
            topic: null,
            category: null,
            industry: null,
            region: null,
            certification: null,
        },
    },

    computed: {
        heroImage () {
            const element = this.$store.getters['resourceTypes/element'](this.params.type)
            return element && element.imageUrl
        },
        nextPage () {
            const urlParams = new URLSearchParams(location.search)
            urlParams.set('page', this.params.page + 1)
            return '?' + urlParams.toString()
        },
        showFeaturedItems () {
            return (
                this.params.search == '' &&
                this.params.sortOrder == '' &&
                this.params.type == null &&
                this.params.topic == null &&
                this.params.category == null &&
                this.params.industry == null &&
                this.params.region == null &&
                this.params.certification == null
            )
        },
    },

    watch: {
        heroImage (val) {
            const heroImage = document.querySelector('.js-heroImage')

            heroImage.dataset.src = typeof val !== 'undefined' ? val : heroImage.dataset.defaultSrc
            heroImage.classList.remove('lazyloaded')
            heroImage.classList.add('lazyload')
        },
    },

    methods: {
        clearFilters () {
            this.params.search = ''
            this.params.sortOrder = ''
            this.params.type = null
            this.params.topic = null
            this.params.category = null
            this.params.industry = null
            this.params.region = null
            this.params.certification = null
            this.params.page = 1
        },
        sortLink (order = 'desc') {
            const urlParams = new URLSearchParams(location.search)
            urlParams.set('sortOrder', order)
            return '?' + urlParams.toString()
        },

    },
})
